import BaseTypeController from "vamos/cockpit/base/controller/BaseTypeController";
import JSONModel from "sap/ui/model/json/JSONModel";
import Dialog from "sap/m/Dialog";
import { DatePicker$ChangeEvent } from "sap/m/DatePicker";
import MessageBox from "sap/m/MessageBox";
import { Request } from "vamos/cockpit/model/odata/VamosModel";
import TimeUtil from "vamos/cockpit/util/TimeUtil";
import V4Context from "sap/ui/model/odata/v4/Context";
import JsonUtil from "vamos/cockpit/base/util/JsonUtil";
import ValidationUtil from "vamos/cockpit/base/util/ValidationUtil";

/**
 * @namespace vamos.cockpit.data.import.problem.controller
 * */
export default class NoProductionDateProblemDialogController extends BaseTypeController {
    private dialog: Dialog;
    private dialogModel: JSONModel;
    private saveCallback: () => void;

    onInit(): void {
        super.onInit();
        this.dialog = this.getView().byId("noProductionDateProblemDialog") as Dialog;
    }

    public openDialog(contexts: V4Context[], saveCallback: () => void): void {
        this.saveCallback = saveCallback;
        this.dialogModel = new JSONModel({
            contexts: contexts,
            currentIndex: 0,
            total: contexts.length,
            currentRequest: null,
            productionDate: null,
        });

        this.getView().setModel(this.dialogModel, "productionDateDialog");
        this.updateForCurrentRequest();
        this.dialog.open();
    }


    public onClosePopup(): void {
        if(this.getCurrentIndex() !== 0){
            this.saveCallback?.();
        }
        this.dialog.close();
    }

    public onChangeProductionDate(event: DatePicker$ChangeEvent): void {
        const selectedDate = event.getSource().getDateValue();
        if (!selectedDate) {
            return;
        }
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        selectedDate.setHours(0, 0, 0, 0);
        if (selectedDate < today) {
            MessageBox.warning(this.getText("ProductionDateInPast"));
        }
    }

    public async onSaveAndNext(): Promise<void> {
        if (ValidationUtil.hasEmptyRequiredFields(this.dialog)) {
            return;
        }

        const context:V4Context = this.getCurrentRequestContext();
        const productionDate = this.dialogModel.getProperty("/productionDate") as string;

        this.dialog.setBusy(true);
        try {
            JsonUtil.json2OData(context, { ProductionDate: productionDate }, "changes");
            await this.submitBatch();
            this.goToNextRequestOrClose();
        } finally {
            this.dialog.setBusy(false);
        }
    }

    private goToNextRequestOrClose(): void {
        const currentIndex =this.getCurrentIndex();
        const total = this.dialogModel.getProperty("/total") as number;
        const nextIndex = currentIndex + 1;
        if (nextIndex >= total) {
            this.saveCallback?.();
            this.closePopup();
        } else {
            this.dialogModel.setProperty("/currentIndex", nextIndex);
            this.updateForCurrentRequest();
        }
    }

    private getCurrentRequestContext(): V4Context | null {
        const requests = this.dialogModel.getProperty("/contexts") as V4Context[];
        const currentIndex = this.getCurrentIndex();
        return requests[currentIndex] ?? null;
    }
    private getCurrentRequest(): Request | null {
        return this.getCurrentRequestContext()?.getObject() as Request;
    }
    private getCurrentIndex(): number {
        return this.dialogModel.getProperty("/currentIndex") as number;
    }

    private updateForCurrentRequest(): void {
        const request = this.getCurrentRequest();
        this.dialogModel.setProperty("/currentRequest", request);
        this.dialogModel.setProperty("/productionDate", TimeUtil.formatIntoV4Date(new Date()));
    }
    private closePopup(): void {
        this.dialog.close();
    }
}
